const users = {
  users: 'Usuarios',
  first_name: 'Nombre',
  last_name: 'Apellido',
  login: 'Inicio de Sesión',
  edit_user: 'Usuario',
  user_details: 'Detalles del Usuario',
  add_user: 'Nuevo Usuario',
  add_new_user_modal_title: 'Agregar nuevo usuario',
  user_created_successfully: 'Usuario creado correctamente',
  could_not_create_user: 'No se pudo crear el usuario',
  search_user: 'Buscar Usuario',
  display_events: 'Mostrar eventos',
  select_at_least_one_user_to_view_events:
    'Seleccione al menos un usuario para ver eventos',
  max_selection_reached: 'Puedes seleccionar un máximo de {{ count }} usuarios',
  delete_user_message:
    '¿Está seguro de que desea eliminar a {{user}}? <br> Si el usuario tiene cartas asociadas estas también serán desasignadas.',
  delete_morethan_one_site:
    'NOTA: Este usuario está asociado con más de un sitio, se eliminará de todos ellos.',
  confirm_modal_confirm: 'Sí, eliminar',
  remove_login: 'Eliminar inicio de sesión',
  remove_confirmation_msg:
    '¿Está seguro de que desea eliminar el acceso web del usuario?',
  activate_confirm_msg:
    '¿Estás seguro de que quieres {{action}} a {{user}} para la cuenta {{account}}?',
  access_levels: 'Niveles de acceso',
  no_custom_fields:
    'No hay campos personalizados configurados para este sitio.',
  general_information: 'Información general',
  custom_fields: 'Campos personalizados',
  custom_fields_success: 'Campos personalizados guardados con éxito',
  custom_field_type_single_line_string: 'Campo de texto',
  custom_field_type_numeric: 'Numérico',
  custom_field_type_date: 'Fecha',
  custom_field_type_email: 'Correo electrónico',
  custom_field_type_checkbox: 'Casilla de verificación',
  custom_field_type_true_or_false: 'Verdadero o falso',
  unassign_site_credentials_note:
    'Desasignar al usuario de este sitio implicará la desasignación de sus posibles credenciales.',
  unassign_site_last_site_note:
    'También implicará la eliminación del usuario de esta cuenta.',
  access_rights: 'Derechos de acceso',
  table: {
    first_name: 'NOMBRE',
    last_name: 'APELLIDO',
    email: 'CORREP',
    user: 'USUARIO',
    role: 'ROL',
    phone: 'TELÉFONO',
    last_login: 'ÚLTIMO INICIO DE SESIÓN',
    status: 'ESTADO',
  },
  form: {
    username: 'Nombre de Usuario',
    email: 'Correo Electrónico',
    phone_number: 'Número de Teléfono',
    date_created: 'Fecha de Creación',
    date_updated: 'Fecha de Actualización',
    new_password: 'Nueva Contraseña',
    role: 'Rol',
    select_role: 'Seleccionar Rol',
    no_role: 'Sin rol',
    define_email:
      'Define una dirección de correo electrónico para este usuario antes de asignarle un rol.',
    set_as_admin: 'Establecer como {{role}}',
  },
  profile: {
    actions: 'Acciones',
    role_details: 'Detalles del rol',
    company_organization: 'Empresa/Organización',
    remove_from_company_confirm:
      '¿Está seguro de que desea retirar a {{name}} de {{company}}? Importante: esta acción no es reversible.',
    change_role_confirm:
      '¿Está seguro de que desea cambiar el rol de {{name}} de {{prevRole}} a {{currentRole}}? Importante: esta acción no es reversible.',
    roles_table_aria_label: 'Tabla de roles y empresas del usuario',
    location: 'Ubicación',
    device: 'Dispositivo',
    ip_address: 'Dirección IP',
    date_time: 'Fecha/Hora',
    profile: 'Detalles de Usuario',
    update: 'Actualizar',
    activities: 'Actividades',
    change: 'Cambiar',
    user_updated: 'El perfil de usuario ha sido actualizado',
    user_updated_success: 'Usuario actualizado correctamente',
    could_not_update_user: 'No se pudo actualizar el usuario',
    profile_deleted: 'Perfil de usuario eliminado',
    could_not_delete_profile: 'No se pudo eliminar el perfil de usuario',
    role_updated: 'Rol actualizado',
    could_not_update_role: 'No se pudo actualizar el rol',
    allowed_filetypes: 'Tipos de archivos permitidos: png, jpg, jpeg.',
    avatar_modal_description: '¿Seguro de que quieres eliminar tu avatar?',
    login_sessions: 'Sesiones de inicio de sesión',
  },
  add: {
    country: 'País',
    city: 'Ciudad',
    address: 'Direccion',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    assign_card: 'Asignar credenciales',
    none: 'Ninguno',
    first_registration: 'Primera inscripción',
    coming_from_another_site: 'Procedente de otro sitio',
    user_found: '¡Usuario encontrado!',
    no_user_found:
      'No se ha encontrado ningún usuario asociado a esta credencial, por favor utilice otra tarjeta.',
    use_this_user: 'Utilice este usuario',
    no_reader: 'Sin lector',
  },
  security: {
    allow_extend_time: 'Permitir extender el tiempo',
    allow_antipassback_override: 'Permitir anulacion anti-passback',
    activation_date: 'Fecha de Activación',
    expiration_date: 'Fecha de Expiración',
    generate_keypad_code: 'Generar un nuevo código de teclado',
    all: 'Todos',
  },
  card: {
    assign_a_card: 'Asignar una credencial',
    credential: 'Credencial',
    assign: 'Asignar',
    activation_date: 'Fecha de activacion',
    to: 'a',
    format: 'Formato',
    card_number: 'Número de credencial',
    assign_card_confirm:
      '¿Quiere asignar la Credencial {{number}} a {{username}}?',
    confirm_btn: 'Confirmar',
    display_name: 'Nombre para mostrar',
  },
  delete: {
    success: 'El usuario {{name}} fue eliminado exitosamente',
    error: 'No se pudo eliminar',
  },
  error: {
    invalid_email: 'Formato de correo electrónico no válido',
    invalid_date: 'Formato de fecha no válido',
  },
  events: {
    tabTitle: 'Eventos',
  },
};

export default users;
